import { render, staticRenderFns } from "./logs.vue?vue&type=template&id=31238156&scoped=true&"
import script from "./logs.vue?vue&type=script&lang=ts&"
export * from "./logs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31238156",
  null
  
)

export default component.exports